(function($){
  /**
   * ・logo パーツの結合と色 定義(define)
   * ・色はHSV形式で定義
   * ・main visualの
   */
	OH.settings.headerDefine = (function(){
		var define = new Object();

    // logo パーツの羅列
		define.logoURL = {
			general  : "/assets/images/logo_01.svg",
			brightbg : "/assets/images/logo_01.svg",
			skybg    : "/assets/images/logo_02.svg",
			darkbg   : "/assets/images/logo_03.svg"
		};

		define.logoElementBase = {
			tagName : "img",
			width : 125,
			height : 28
		};

    // logo 結合
		define.createLogoElement = function(imageURL){
			imageURL = !!imageURL ? imageURL : define.logoURL.general;
			return $('<' + define.logoElementBase.tagName + '>').attr("width", define.logoElementBase.width).attr("height", define.logoElementBase.height).attr("src", imageURL);
		};
    
    // logo 色可変
		define.logoSource = function(hsv){
			//if(OH.settings.headerControl.isFixed()){
			//	return define.logoURL.general;
			//}
			if(150 < hsv.h && hsv.h < 240 && 10 < hsv.s && hsv.s < 50 && 50 < hsv.m && hsv.m < 80){
				return define.logoURL.skybg;
			}
			if(hsv.m < 50){
				return define.logoURL.darkbg;
			}
			return define.logoURL.brightbg;
		};

    // main visualの横幅処理
		define.adjustMainVisual = function(serial, $parent){
			var transformProp = OH.transitionalStyleProperty("transform", "_");
			var transformOriginProp = OH.transitionalStyleProperty("transform-origin", "_");
      
			OH.onResizeTasks.append(serial, function(){
				var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				var scale = 1;
				if(768 < width){
					scale = Math.min(1, (width - OH.scrollbarWidth) / 960);
					$parent.height((370 + 135 + 40) * scale);
					$parent.css("margin-bottom", "");
				}
				else{
					scale = (width - OH.scrollbarWidth) / 400;
					$parent.height(320 - 30);
					$parent.css("margin-bottom", 320 * (scale - 1) + "px");
				}
      
				if(scale < 1){
					$parent.css(transformProp, "scale(" + scale + ")");
					$parent.css(transformOriginProp, "0px 0px");
				}
				else if(scale > 1){
					$parent.css(transformProp, "scale(" + scale + ")");
					$parent.css(transformOriginProp, "50% 0%");
				}
				else{
					$parent.css(transformProp, "");
					$parent.css(transformOriginProp, "");
				}
      
			}, true);
		};

		return define;
	})();
})(jQuery);
